import core from "@/helpers/client";
import VueCookies from "vue-cookies";


const groupService = {
  async headGroupAsync(applicationId,params) {
    let accessToken = VueCookies.get(".psg.at");
    const result = await core.head(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}/api/v1/applications/${applicationId}/groups?no-cache=1`,
      params,
      {
        headers: {'Authorization' : 'Bearer ' + accessToken}
      }
    );
    return result;
  },
  async getGroupsAsync(applicationId,params) {
    let accessToken = VueCookies.get(".psg.at");
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}/api/v1/applications/${applicationId}/groups?no-cache=1`,
      params, 
      {
        headers: {'Authorization' : 'Bearer ' + accessToken}
      }
    );
    return result;
  },
  async getGroupAsync(applicationId,id) {
    let accessToken = VueCookies.get(".psg.at");
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}/api/v1/applications/${applicationId}/groups/${id}?no-cache=1`
      ,
      {},
      {
        headers: {'Authorization' : 'Bearer ' + accessToken}
      }
    );
    return result;
  },
  async getCodeByGroupInviteAsync(applicationId, code) {
    let accessToken = VueCookies.get(".psg.at");
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}/api/v1/applications/${applicationId}/groups/invites/${code}?no-cache=1`,
      {},
      {
        headers: {'Authorization' : 'Bearer ' + accessToken}
      }
    );
    return result;
  },
  async createGroupAsync(applicationId,model) {
    let accessToken = VueCookies.get(".psg.at");
    const result = await core.create(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}/api/v1/applications/${applicationId}/groups`,
      model,
      {
        headers: {'Authorization' : 'Bearer ' + accessToken}
      }
    );
    return result;
  },
  async createCodeByGroupInviteAsync(applicationId, id, model) {
    let accessToken = VueCookies.get(".psg.at");
    const result = await core.create(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}/api/v1/applications/${applicationId}/groups/${id}/invites`,
      model,
      {
        headers: {'Authorization' : 'Bearer ' + accessToken}
      }
    );
    return result;
  },
  async createGroupUserByCodeInviteAsync(applicationId, inviteCode, model) {
    let accessToken = VueCookies.get(".psg.at");
    const result = await core.create(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}/api/v1/applications/${applicationId}/groups/invites/${inviteCode}`,
      model,
      {
        headers: {'Authorization' : 'Bearer ' + accessToken}
      }
    );
    return result;
  },
  async updateGroupAsync(applicationId,id, model) {
    let accessToken = VueCookies.get(".psg.at");
    const result = await core.update(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}/api/v1/applications/${applicationId}/groups/${id}`,
      model,
      {
        headers: {'Authorization' : 'Bearer ' + accessToken}
      }
    );
    return result;
  },
  async patchGroupAsync(applicationId, id, model) {
    let accessToken = VueCookies.get(".psg.at");
    const result = await core.edit(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}/api/v1/applications/${applicationId}/groups/${id}`, model ,
      {
        headers: {'Authorization' : 'Bearer ' + accessToken}
      }
    );
    return result;
  },
  async deleteGroupByIdAsync(applicationId,id) {
    let accessToken = VueCookies.get(".psg.at");
    const result = await core.delete(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}/api/v1/applications/${applicationId}/groups/${id}`,
      {},
      {
        headers: {'Authorization' : 'Bearer ' + accessToken}
      }
    );
    return result;
  },
  async deleteGroupUserByUserIdAsync(applicationId, id, userId) {
    let accessToken = VueCookies.get(".psg.at");
    const result = await core.delete(
      `${process.env.VUE_APP_BASE_API_AUTHORIZE}/api/v1/applications/${applicationId}/groups/${id}/users/${userId}`,{},
      {
        headers: {'Authorization' : 'Bearer ' + accessToken}
      }
    );
    return result;
  },
};
export default groupService;
